import { ArticleHeading1, ArticleHeading2, Image, UIText3, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';
import { CheckmarkBulletPoint } from '../CheckmarkBulletPoint';
import { IPaymentMethod } from '../../types/redux/promoInfo';

import * as styles from './styles.css';

export const PaymentMethodCard: React.FC<IPaymentMethod & { isFirst: boolean }> = props => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const isDesktop = deviceType === 'desktop';
  const TitleComponent = (() => {
    if (!isMobile && props.isFirst) {
      return ArticleHeading1;
    }

    return ArticleHeading2;
  })();

  return (
    <div className={cn(styles['card-wrapper'], styles[deviceType])}>
      <div className={cn(styles['card'], props.isFirst && styles['card-main'])}>
        <div className={styles['name-and-features']}>
          {props.icon && (
            <div className={styles['icon']}>
              <Image
                display="block"
                src={props.icon}
                width={props.isFirst ? 60 : undefined}
                height={props.isFirst ? 60 : 24}
                loading="lazy"
              />
            </div>
          )}
          <TitleComponent>{props.title}</TitleComponent>
          <ul className={styles['features-list']}>
            {props.details.map((detail, i) => (
              <CheckmarkBulletPoint key={i} checkmarkColor="gray60_100">
                {detail}
              </CheckmarkBulletPoint>
            ))}
          </ul>
        </div>
        {props.price && (
          <div className={styles['price']}>
            <ArticleHeading1>{props.price}</ArticleHeading1>
          </div>
        )}
        {props.advertisingNotice && (
          <div className={styles['advert']}>
            <UIText3 color="current_color">{props.advertisingNotice}</UIText3>
          </div>
        )}
      </div>
      {props.image && isDesktop && (
        <div className={styles['image']}>
          <Image
            objectFit="cover"
            src={props.image.x1}
            sources={[
              {
                srcset: props.image.x2,
                media: X2_IMAGE_SIZE_MEDIA_QUERY,
              },
              { srcset: props.image.x1 },
            ]}
            width={365}
            height={320}
            loading="lazy"
          />
        </div>
      )}
    </div>
  );
};
